import type { ActivationSetSchema } from "app/pages/activation/types/api";

export const PROJECTS_LIST_MOCK: ActivationSetSchema[] = [
    {
        accountId: "mock-account-id",
        addedTime: "2024-01-15T10:30:00Z",
        allDomains: ["mycompany.com", "competitor1.com", "competitor2.com"],
        canEdit: true,
        competitorsDomains: ["competitor1.com", "competitor2.com"],
        country: 840,
        id: "mock-project-id",
        isFavorite: false,
        isOwn: true,
        lastUpdated: "2024-01-20T14:45:00Z",
        name: "Project: My Company 1",
        primaryDomain: "mycompany.com",
        userId: "mock-user-id",
        isSubscribed: false,
        share: 0,
        shareTrend: [],
    },
    {
        accountId: "mock-account-id-2",
        addedTime: "2024-02-03T09:15:00Z",
        allDomains: ["mycompany.com", "amazon.co.uk", "ebay.co.uk", "argos.co.uk"],
        canEdit: true,
        competitorsDomains: ["amazon.co.uk", "ebay.co.uk", "argos.co.uk"],
        country: 826,
        id: "mock-project-id-2",
        isFavorite: true,
        isOwn: true,
        lastUpdated: "2024-02-18T16:30:00Z",
        name: "Project: My Company 2",
        primaryDomain: "mycompany.com",
        userId: "mock-user-id",
        isSubscribed: false,
        share: 0,
        shareTrend: [],
    },
    {
        accountId: "mock-account-id-3",
        addedTime: "2024-03-12T14:22:00Z",
        allDomains: ["mycompany.com", "zalando.de", "otto.de"],
        canEdit: true,
        competitorsDomains: ["zalando.de", "otto.de"],
        country: 276,
        id: "mock-project-id-3",
        isFavorite: false,
        isOwn: true,
        lastUpdated: "2024-03-25T11:45:00Z",
        name: "Project: My Company 3",
        primaryDomain: "mycompany.com",
        userId: "mock-user-id-2",
        isSubscribed: false,
        share: 0,
        shareTrend: [],
    },
    {
        accountId: "mock-account-id-4",
        addedTime: "2024-04-08T13:10:00Z",
        allDomains: ["mycompany.com", "leboncoin.fr", "cdiscount.fr", "fnac.com", "darty.com"],
        canEdit: true,
        competitorsDomains: ["leboncoin.fr", "cdiscount.fr", "fnac.com", "darty.com"],
        country: 250,
        id: "mock-project-id-4",
        isFavorite: false,
        isOwn: true,
        lastUpdated: "2024-04-20T08:20:00Z",
        name: "Project: My Company 4",
        primaryDomain: "mycompany.com",
        userId: "mock-user-id",
        isSubscribed: true,
        share: 0,
        shareTrend: [],
    },
    {
        accountId: "mock-account-id-5",
        addedTime: "2024-05-14T11:35:00Z",
        allDomains: ["mycompany.com", "mercadolibre.com.mx", "amazon.com.mx", "coppel.com"],
        canEdit: true,
        competitorsDomains: ["mercadolibre.com.mx", "amazon.com.mx", "coppel.com"],
        country: 484,
        id: "mock-project-id-5",
        isFavorite: true,
        isOwn: true,
        lastUpdated: "2024-05-28T15:55:00Z",
        name: "Project: My Company 5",
        primaryDomain: "mycompany.com",
        userId: "mock-user-id",
        isSubscribed: false,
        share: 0,
        shareTrend: [],
    },
];
